import { render } from "./PackageViewComponent.vue?vue&type=template&id=2b03a1c2"
import script from "./PackageViewComponent.vue?vue&type=script&lang=js"
export * from "./PackageViewComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__